<template>
  <section v-if="episode">
    <article class="container article episode">
      <router-link :to="{ name: 'Post', params: { slug: episode.slug } }" class="image" :style="{ backgroundImage: 'url(' + featuredImage + ')' }">
      </router-link>
      <div class="content">
        <router-link :to="{ name: 'Post', params: { slug: episode.slug } }"><h2 v-html="episode.title"></h2></router-link>
        <p><span v-html="episode.excerpt"></span> <router-link :to="{ name: 'Post', params: { slug: episode.slug } }" class="more-link">More</router-link></p>
        <div class="playModule">
          <div class="playButton">
            <router-link :to="{ name: 'Post', params: { slug: episode.slug } }"><span v-if="episodeNumber">{{ episodeNumber }} &bull; </span>{{ formattedPubDate }}</router-link>
          </div>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: 'hero',
  props: ['episode'],
  computed: {
    episodeNumber () {
      if (this.episode.lstplus) {
        return 'LST+'
      } else if (this.episode.number) {
        return 'Episode #' + this.episode.number
      }
    },
    formattedPubDate () {
      let vm = this
      return vm.$moment(vm.episode.date).format('MM.DD.YY')
    },
    featuredImage () {
      let vm = this
      let image = vm.episode.image.large
      if (process.env.NODE_ENV === 'development') {
        image = image.replace('http://longestshortesttime.duck/app', 'http://cdn.longestshortesttime.com/wp-content')
      }
      return image
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/colors
  @import ../../assets/styles/mixins

  section
    padding: 0
    .container
      +smDesktop
        display: flex
        flex-direction: row-reverse

  .episode
    position: relative
    +until($tablet)
      border-top: 0
      border-bottom: 0

  .image
    background-size: cover
    background-position: center center
    max-width: 100%
    height: 0
    padding-bottom: 60%
    border-bottom: 5px solid $turquoise
    +smDesktop
      width: 50%
      height: auto
      padding: 0
      border-bottom: none
    +desktop
      width: 636px

  .content
    padding: 50px 30px
    position: relative
    +tablet
      display: block
      flex: 1
      padding: 3rem 1.5rem 0 2.5rem
    h2
      font-size: 32px
      font-weight: bold
      line-height: 38px
      &:hover
        color: lighten($textColor, 25%)
    p
      font-size: 20px
      line-height: 34px
      margin-bottom: 0
      +tablet
        margin-bottom: 1em
        min-height: 136px
    .playModule
      position: absolute
      top: -6px
      left: 50%
      width: calc(100% - 60px)
      transform: translate(-50%, -50%)
      +tablet
        transform: none
        position: static
        top: 0
        .playButton
          margin-top: 3rem
      .playButton
        position: relative
        top: 1px
        display: flex
        align-items: center
        width: 100%
        border: none
        background: $turquoise
        text-align: left
        font-size: 20px
        padding: 1rem 1.5rem
        color: $textColor
        a
          color: inherit
          &:hover
            text-decoration: underline
</style>



// WEBPACK FOOTER //
// Hero.vue?6bf79eb5